export default function MainFooter() {
    return (
      <div className="bg-black text-center lg:text-left">
        <div className="text-gray-400 p-4 text-center">
          © 2024 Kenyans.co.ke. All rights reserved
        </div>
      </div>
    );
  }